import { createContext, useContext, useState } from 'react'

export interface DialogState {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  title?: string
  setTitle: (title: string) => void
  cancelBtnText?: string
  setCancelBtnText: (text: string) => void
  nextBtnText?: string
  setNextBtnText: (text: string) => void
  contentClass?: string
  setContentClass: (contentClass: string) => void
  data?: any
  setData: (data: any) => void
  onClose?: (result?: boolean) => void
  setOnClose: (func?: (result?: boolean) => void) => void
}

export const DialogStateContext = createContext<DialogState>({} as DialogState)

const DialogStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setOpen] = useState<DialogState['isOpen']>(false)
  const [contentClass, setContentClass] = useState<DialogState['contentClass']>(undefined)
  const [title, setTitle] = useState<DialogState['title']>(undefined)
  const [cancelBtnText, setCancelBtnText] = useState<DialogState['title']>(undefined)
  const [nextBtnText, setNextBtnText] = useState<DialogState['title']>(undefined)
  const [data, setData] = useState<DialogState['data']>(undefined)
  const [onClose, setOnClose] = useState<DialogState['onClose']>(undefined)

  return (
    <DialogStateContext.Provider
      value={{
        isOpen,
        setOpen,
        contentClass,
        setContentClass,
        title,
        setTitle,
        cancelBtnText,
        setCancelBtnText,
        nextBtnText,
        setNextBtnText,
        data,
        setData,
        onClose,
        setOnClose,
      }}
    >
      {children}
    </DialogStateContext.Provider>
  )
}
export default DialogStateProvider

export const useDialogState = () => useContext(DialogStateContext)
